import { render } from "./MdTableAlternateHeader.vue?vue&type=template&id=15367c20"
import script from "./MdTableAlternateHeader.vue?vue&type=script&lang=js"
export * from "./MdTableAlternateHeader.vue?vue&type=script&lang=js"

import "./MdTableAlternateHeader.vue?vue&type=style&index=0&id=15367c20&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__